import React from "react";
import PropTypes from "prop-types";
import CopyrightsPanel from "../containerPanels/CopyrightsContainerPanel";
import SocialMediaPanel from "../components/SocialMediaPanel";

const Footer = ({ isVertical }) => {
  return (
    <footer>
      <CopyrightsPanel />
      {!isVertical && <SocialMediaPanel isVertical={isVertical} />}
    </footer>
  );
};

Footer.propTypes = {
  isVertical: PropTypes.bool,
};

Footer.defaultProps = {
  isVertical: false,
};

export default Footer;
